import { en } from './locales/en';

export const t = (value: string): string => {
  return en[value] || value;
};
